var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"options-navig-column options-biggest-column selected-client",on:{"click":this.$helper.addFocus}},[_c('select',{staticClass:"client-select",class:"clients_input"},[_c('option')])])}
var staticRenderFns = []

export { render, staticRenderFns }